import { Col, Row } from "react-bootstrap";
import { IFullLicenceDetails } from "../../../../api/LicenceDetails";
import EpaCard from "../../../../leap-components/EpaCard";
import EpaField from "../../../../leap-components/EpaField";

interface LicenceDetailsProps {
  licence: IFullLicenceDetails;
}

const KeyDates = ({ licence }: LicenceDetailsProps) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <EpaField label={"Application Date"} value={licence.authappdate} />
          <EpaField
            label={"Proposed Authorisation Issued"}
            value={licence.propappissued}
          />
          <EpaField
            label={"Closing Dates for Objections"}
            value={licence.objectionsclosingdate}
          />
          <EpaField
            label={"Final Authorisation Issued"}
            value={licence.licenceissueddate}
          />
          <EpaField
            label={"Authorisation Expiry Date"}
            value={licence.expirydate}
          />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Key Dates"} content={bodyElements} />;
};

export default KeyDates;
